import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 2rem;
  color: #2D3748;
  letter-spacing: .05rem;
  margin: 0 0 2.5rem;
  line-height: 1.3;

  @media (min-width: 50rem) {
    font-size: 2.5rem;
  }

  ${props => props.textCenter && `
    text-align: center;
  `}

  ${props => props.small && `
    font-size: 1.2rem !important;
  `}
`;
